import { render, staticRenderFns } from "./DVfieldDate.vue?vue&type=template&id=2983c41a&scoped=true"
import script from "./DVfieldDate.vue?vue&type=script&lang=js"
export * from "./DVfieldDate.vue?vue&type=script&lang=js"
import style0 from "./DVfieldDate.vue?vue&type=style&index=0&id=2983c41a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2983c41a",
  null
  
)

export default component.exports